@if (imageBoolean) {
  <img class="attachmentFiles" [src]="imageUrl" style="max-width:100%; max-height:93vh; display:block; margin:auto;" />
}
@if (docBoolean) {
  <ngx-doc-viewer [url]="docUrl" viewer="google"  style="width:100%;height:93vh;"></ngx-doc-viewer>
}

@if (pdfBoolean) {
  <ngx-extended-pdf-viewer [src]="pdfUrl"></ngx-extended-pdf-viewer>
}

@if (audioBoolean) {
  <div id="newTab">
    <audio controls>
      <source [src]="audioUrl" type="audio/mpeg">
    </audio>
  </div>
}